import { atom } from "recoil";

interface CreditLimitDetailState {
  customerNo: string;
  countInvoiceStatus: any;
}

export const creditLimitDetailState = atom<CreditLimitDetailState>({
  key: "CreditLimitDetail",
  default: {
    customerNo: "",
    countInvoiceStatus: {
      ALREADY_PAID: 0,
      WAITING_PAID: 0,
    },
  },
});
